import React from 'react'
import { createRoot } from 'react-dom/client'
import Root from './App'
import KeycloakService from './utils/keycloakService'
import { BrowserRouter } from 'react-router-dom'
import './index.css'

const container = document.getElementById('root')
const root = createRoot(container as HTMLElement)

const renderRoot = () => {
  root.render(
    <BrowserRouter>
      <Root />
    </BrowserRouter>
  )
}
KeycloakService.initKeycloak(renderRoot)
